
document.addEventListener("DOMContentLoaded", function () {
  let loading = false;
  const container = document.querySelector(".collection .grid"); // Products grid
  const observer = new IntersectionObserver(async (entries) => {
    if (entries[0].isIntersecting && !loading) {
      const nextBtn = document.querySelector(".pagination a[aria-label='Next page']");
      if (nextBtn) {
        loading = true;
        const nextUrl = nextBtn.getAttribute("href");

        // Fetch next page HTML
        const response = await fetch(nextUrl);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, "text/html");

        // Get new products
        const newItems = doc.querySelectorAll(".collection .grid .grid__item");
        newItems.forEach((item) => container.appendChild(item));

        // Replace pagination with new one
        const newPagination = doc.querySelector(".pagination");
        document.querySelector(".pagination").innerHTML = newPagination.innerHTML;

        loading = false;
      }
    }
  }, { rootMargin: "200px" });

  const pagination = document.querySelector(".pagination");
  if (pagination) {
    observer.observe(pagination);
  }
});

